import { ColumnModel } from '@syncfusion/ej2-react-grids';

import { DropDownData } from 'components/Common/SyncfusionWrappers/Syncfusion';
import {
    IPreferredStatusMapping,
    PreferredStatusMappingSubmitMode,
} from 'components/ProviderData/IpaAdministration/atoms/Models';
import { IpaPreferredStatusService } from 'components/ProviderData/subjects/IpaPreferredStatusService';
import { dialogService } from 'subjects/common/DialogService';

export const getPreferredStatusFormButtons = ({
    isReadOnly,
    mode,
}: {
    isReadOnly: boolean;
    mode: PreferredStatusMappingSubmitMode;
}) => [
    {
        buttonModel: {
            disabled: isReadOnly,
            content: 'Save',
            iconCss: 'e-icons e-save-icon',
            cssClass: 'e-submit',
        },
        click: () => IpaPreferredStatusService.submit(mode),
    },
    {
        buttonModel: {
            disabled: isReadOnly,
            content: 'Cancel',
            iconCss: 'e-icons e-cancel-icon',
            cssClass: 'e-cancel',
        },
        click: () => dialogService.close(),
    },
];

export const getPreferredStatusGridColumns: (
    preferredStatusCodes: DropDownData[],
) => (ColumnModel & { field: keyof IPreferredStatusMapping })[] = (preferredStatusCodes) => [
    {
        field: 'tin',
        width: 125,
        headerText: 'TIN',
    },
    {
        field: 'statusCode',
        width: 250,
        headerText: 'Preferred Status',
        valueAccessor: (_, data: any) => {
            const status = preferredStatusCodes.find((code) => code.id === data.statusCode);
            return status ? status.desc : `${data.statusCode} - Invalid`;
        },
    },
    {
        field: 'startDate',
        width: 100,
        headerText: 'Start Date',
        type: 'date',
        format: 'MM/dd/yyyy',
    },
    {
        field: 'endDate',
        width: 100,
        headerText: 'End Date',
        type: 'date',
        format: 'MM/dd/yyyy',
    },
    {
        field: 'createdByName',
        width: 150,
        headerText: 'Created By',
    },
    {
        field: 'createdAt',
        width: 100,
        headerText: 'Created Date',
        type: 'date',
        format: 'MM/dd/yyyy',
    },
    {
        field: 'lastUpdatedByName',
        width: 150,
        headerText: 'Updated By',
    },
    {
        field: 'lastUpdatedAt',
        width: 100,
        headerText: 'Updated Date',
        type: 'date',
        format: 'MM/dd/yyyy',
    },
    {
        field: 'id',
        width: 125,
        headerText: 'Id',
        isPrimaryKey: true,
        visible: false,
    },
];
